import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// @ts-ignore
import store from '@/stores'; // Import your Vuex store
import { createPinia } from 'pinia';

import './assets/css/app.css';
// @ts-ignore
import sessionPlugin from '@/plugins/session';
// @ts-ignore
import i18n from '@/lang/i18n';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
// import './assets/license.js';

const app = createApp(App);

app.use(createPinia());
app.use(store); // Use the Vuex store
app.use(router);
app.use(sessionPlugin);
app.use(i18n)
app.component('VueDatePicker', VueDatePicker);

app.mount('#app');
